import initialState from 'core/reducers/initialState';
import ActionTypes from './../actions/actionTypes';

export default function paramsReducer(state = initialState.params, action: any) {
	switch (action.type) {
		case ActionTypes.ADD_ITEMS_TO_CART: {
			return {
				...state,
				cartItems: [...state.cartItems, ...action.payload],
			};
		}

		case ActionTypes.REMOVE_ITEMS_FROM_CART: {
			//used to remove item from cart
			const existingCartItems = [...state.cartItems];
			const updatedCartItems = existingCartItems.filter((item) => item["id"] !== action.payload);

			return {
				...state,
				cartItems: updatedCartItems,
			};
		}

		case ActionTypes.RESET_CART: {
			return {
				...state,
				cartItems: [],
				quantityInCart: [],
				discountResponse: null,
				cartUserDetails: null,
				shippableUserDetails: null,
			};
		}

		case ActionTypes.REMOVE_QUANTITY_FROM_CART: {
			// used to update or remove quantity
			const updatedQuantityInCart = state.quantityInCart.filter(
				(item) => item.courseId !== action.payload
			);

			return {
				...state,
				quantityInCart: updatedQuantityInCart,
			};
		}

		case ActionTypes.SET_QUANTITY_IN_CART: {
			return {
				...state,
				quantityInCart: [...action.payload],
			};
		}

		case ActionTypes.SET_DISCOUNT_RESPONSE: {
			return {
				...state,
				discountResponse: action.payload,
			};
		}

		case ActionTypes.SAVE_CART_USER_DETAILS: {
			return {
				...state,
				cartUserDetails: action.payload,
			};
		}

		case ActionTypes.SAVE_SHIPPABLE_USER_DETAILS: {
			return {
				...state,
				shippableUserDetails: action.payload,
			};
		}

		case ActionTypes.SAVE_FORUM_ID: {
			return {
				...state,
				forumId: action.payload && action.payload.forumId
			}
		}
		case ActionTypes.SAVE_USER_PERMISSION: {
			return {
				...state,
				userPermission: action.payload && action.payload
			}
		}


		case ActionTypes.SET_CART_ITEMS_GROUP_BUY: {
			return {
				...state,
				cartItemsGroupBuy: action.payload,
			};
		}

		case ActionTypes.QUERY_PARAMS_UPDATE:
			const updated = {
				...state.panel[action.instance],
				...action.params,
			};
			return {
				...state,
				panel: { ...state.panel, [action.instance]: updated },
			};
		case ActionTypes.QUERY_PARAMS_REPLACE:
			return {
				...state,
				panel: {
					...state.panel,
					[action.instance]: { ...action.params },
				},
			};
		case ActionTypes.QUERY_FORCE_REFRESH:
			return { ...state, refresh: (state.refresh || 0) + 1 };
		case ActionTypes.BREADCRUMBS_UPDATE:
			return { ...state, breadcrumbs: action.breadcrumbs || [] };
		case ActionTypes.SET_TRACK_PAGINATION:
			if (!state.trackPaginationVal.length) {
				// if no pagination value is present
				return {
					...state,
					trackPaginationVal: [...action.trackPaginationVal],
				};
			}

			let existingTracks = [];
			state.trackPaginationVal.map((val) => {
				// add tracks to array for which pagenumbers are present
				existingTracks.push(val.trackId);
			});

			const latestPaginationVal = action.trackPaginationVal[0];
			if (existingTracks.includes(latestPaginationVal.trackId)) {
				const existingPaginationVal = [...state.trackPaginationVal];
				const updatedPagination = existingPaginationVal.map((val) => {
					if (val.trackId === latestPaginationVal.trackId) {
						return {
							...val,
							trackId: latestPaginationVal.trackId,
							pageNumber: latestPaginationVal.pageNumber,
						};
					}
					return val;
				});
				return { ...state, trackPaginationVal: [...updatedPagination] };
			} else {
				return {
					...state,
					trackPaginationVal: [
						...state.trackPaginationVal,
						...action.trackPaginationVal,
					],
				};
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/core/reducers/paramsReducer.ts